/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import EternalUi from '@eternal/Components/Ui/EternalUi';
import WrapLayout from '@Layout/WrapLayout';

/* Services */
import { fetchData } from 'services/eternalServices';
import { eternalMenuQuery, eternalQuery } from 'utils/microsites/eternalQuery';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - EternalEchoes Landing Page Data
 */
const EternalEchoes = ({ region, language, pageData }) => {
  return (
    <WrapLayout>
      <HeadComponent
        data={JSON.parse(pageData)?._seoMetaTags || JSON.parse(pageData)?.seoFields}
        availableLocals={JSON.parse(pageData)?.availableLocales}
      />
      <Box as="section" padding="0">
        <EternalUi
          pageBody={JSON.parse(pageData)?.body}
          region=""
          lang={language}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticProps = async ({ preview, previewData }) => {
  // const headerTopMenuData = await fetchHeaderTopMenuData(
  //   getLocale('', 'en'),
  //   'isotopmenu'
  // );
  // const headerResponse = await fetchData(eternalMenuQuery);
  // console.log(headerResponse, 'headerResponse');
  // const headerMenuData = await headerResponse?.data;
  const footerResponse = await fetchData(eternalMenuQuery);
  const footerData = await footerResponse?.data;
  const response = await fetchData(
    eternalQuery.replace('##pageName##', 'eternal-echoes')
  );
  let pageData = (await response?.data?.allEternalEchoesMicrosites[0]) || [];
  pageData = JSON.stringify(pageData).replace(
    /https:\/\/www.datocms-assets.com\//g,
    `${config.staticPath}/d/`
  );
  JSON.parse(pageData);
  return {
    props: {
      headerTopMenuData: {} || null,
      headerMenuData: {} || null,
      region: 'in',
      language: 'en',
      headerVisible: false,
      footerData: footerData || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default EternalEchoes;
